import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetModelo145ByUser = {
  status: number | null;
  statusText: string | null;
};

const useGetModelo145ByUser = () => {
  const [loadingGetModelo145ByUser, setLoadingGetModelo145ByUser] = useState(false);
  const [successGetModelo145ByUser, setSuccessGetModelo145ByUser] = useState(false);
  const [errorGetModelo145ByUser, setErrorGetModelo145ByUser] = useState<any>(null);
  const [dataGetModelo145ByUser, setDataModelo145ByUser] = useState<any>(null);

  const [statusGetModelo145ByUser, setStatusGetModelo145ByUser] =
    useState<StatusGetModelo145ByUser>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";

  const apirecord = new record.RecordService(
    BASE_URL,
    FUNCTIONS_KEY
  );

  // GET
  const getModelo145ByUser = async (
    userId: string,
    expedienteId: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingGetModelo145ByUser(true);
    setSuccessGetModelo145ByUser(false);
    setErrorGetModelo145ByUser(null);

    try {
      const res = await apirecord.getModelo145ItByUser(userId, expedienteId);

      setStatusGetModelo145ByUser({
        status: res.status,
        statusText: res.statusText ?? res.response ?? null
      });

      setSuccessGetModelo145ByUser(true);
      setDataModelo145ByUser(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {
      const responseData = err?.response?.data;
      const backendMessage =
        (typeof responseData === "string" ? responseData : null) ||
        responseData?.response ||
        responseData?.message ||
        err?.response?.statusText ||
        err?.message ||
        "Error";

      setStatusGetModelo145ByUser({
        status: err?.response?.status || 500,
        statusText: backendMessage
      });

      setErrorGetModelo145ByUser(err);
      console.error("Error en getModelo145ByUser:", err);

      throw err;

    } finally {
      setLoadingGetModelo145ByUser(false);
    }
  };

  return {
    getModelo145ByUser,
    loadingGetModelo145ByUser,
    successGetModelo145ByUser,
    errorGetModelo145ByUser,
    dataGetModelo145ByUser,
    statusGetModelo145ByUser
  };
};

export default useGetModelo145ByUser;
